import { Link } from "react-router-dom";

import { getBaseUrl } from "simplydo/core/helpers";
import { fileDownload } from "simplydo/core/storage";

import { useMe } from "../hooks";

type DownloadLinkProps = {
  url: string;
  name: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const downloadUrlRegex = /^https:\/\/[a-z-]{2,16}\.simplydo\.co\.uk\/download/;

export const DownloadLink = ({
  url,
  name,
  children,
  className,
  style,
}: DownloadLinkProps) => {
  const user = useMe();

  const baseUrl = getBaseUrl(user?.ownerOrganisation);
  const isSimplyDoDownloadLink =
    url.startsWith(baseUrl + "/download") || url.match(downloadUrlRegex);

  if (isSimplyDoDownloadLink) {
    const localHref = url.replace(baseUrl, "");

    return (
      <Link
        to={localHref}
        onClick={(e) => {
          fileDownload(user, e, url, name);
        }}
        className={className}
        style={style}
      >
        {children}
      </Link>
    );
  }

  return (
    <a
      href={url}
      download={name}
      rel="noopener noreferrer"
      target="_blank"
      className={className}
      style={style}
    >
      {children}
    </a>
  );
};
